<template>
    <svg version="1.1"  v-bind:class="{turnOn: isTurnOn}"  id="Candle" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
         viewBox="0 0 250 250" style="enable-background:new 0 0 250 250;" xml:space="preserve">
        <g>
	        <g id="Wax">
                <g>
                    <rect x="100.6" y="69.4" class="st1" width="35.1" height="79.7"/>
                    <path class="st2" d="M135,70.2v78.2h-33.6V70.2H135 M136.5,68.7H99.9v81.2h36.6V68.7L136.5,68.7z"/>
                </g>
                <g>
                    <rect x="121.1" y="68.4" class="st3" width="9.9" height="79"/>
                </g>
                <g>
                    <rect x="99.9" y="144.6" class="st3" width="36.6" height="3.8"/>
                </g>
                <g>
                    <path class="st2" d="M138.9,77.6c-0.2,0.2-0.7,0.6-1.1,0.6c-0.4-0.1-0.5-0.7-0.7-1.4c-0.6-2.6-0.6-2-0.7-2.8c-0.3-2,0-2.5-0.7-3.4c-0.2-0.2-0.8-0.9-1.5-0.8c-0.5,0-0.8,0.5-1.1,0.8c-1.4,2.2-0.4,3.8-1.8,5.3c-0.2,0.2-1.1,1.1-2.2,1.1c-1,0-1.6-0.7-4-3.1c-2.3-2.2-2.8-2.7-3.6-3.1c-0.4-0.2-1.6-0.8-3.3-1.1c-1.8-0.3-3.2-0.6-4.2-0.2c-1.9,1-1.5,5.1-0.6,12.4c0.1,0.6,0.2,2-0.7,2.5c-0.8,0.4-2.1,0.2-2.9-0.3c-1.2-0.7-1.4-2-1.5-2.5c-1.2-9.7-2.5-11.1-3.6-11.7c-1.1-0.6-2.8-1-3.6-0.6c-1,0.5-0.3,1.8-1.8,3.4c-0.5,0.5-1,0.8-1.5,0.8c0,0-0.8,0.1-1.8-0.3c-1.8-0.8-3.4-4.5-1.8-6.7c2.1-3,9-1.2,27.8-1.7c9.9-0.3,13.1-0.9,15.8,1.1C142.2,69.5,140.3,76.3,138.9,77.6z"/>
                    <path class="st4" d="M138.9,76.5c-0.2,0.2-0.7,0.6-1.1,0.6c-0.4-0.1-0.5-0.7-0.7-1.4c-0.6-2.6-0.6-2-0.7-2.8c-0.3-2,0-2.5-0.7-3.4c-0.2-0.2-0.8-0.9-1.5-0.8c-0.5,0-0.8,0.5-1.1,0.8c-1.4,2.2-0.4,3.8-1.8,5.3c-0.2,0.2-1.1,1.1-2.2,1.1c-1,0-1.6-0.7-4-3.1c-2.3-2.2-2.8-2.7-3.6-3.1c-0.4-0.2-1.6-0.8-3.3-1.1c-1.8-0.3-3.2-0.6-4.2-0.2c-1.9,1-1.5,5.1-0.6,12.4c0.1,0.6,0.2,2-0.7,2.5c-0.8,0.4-2.1,0.2-2.9-0.3c-1.2-0.7-1.4-2-1.5-2.5c-1.2-9.7-2.5-11.1-3.6-11.7c-1.1-0.6-2.8-1-3.6-0.6c-1,0.5-0.3,1.8-1.8,3.4c-0.5,0.5-1,0.8-1.5,0.8c0,0-0.8,0.1-1.8-0.3c-1.8-0.8-3.4-4.5-1.8-6.7c2.1-3,9-1.2,27.8-1.7c9.9-0.3,13.1-0.9,15.8,1.1C142.2,68.4,140.3,75.2,138.9,76.5z"/>
                </g>
            </g>
            <path id="Match" class="st5" d="M118.5,64.5h-1.7c0.8-0.6,1.1-1.1,1.3-1.5c0.4-0.8,0.3-1.6,0-3c-0.2-0.9-0.2-0.8-0.4-1.8c-0.2-0.7-0.3-1.3-0.3-2.1c0-0.3,0-0.5,0-0.6c0.1,0,0.2,0,0.3,0c0.3,0,0.6,0,0.8,0c0,0.2,0,0.5,0,0.6c0,1-0.1,1.3,0,1.8c0.1,0.2,0.1,0.5,0.2,0.6c0.2,0.5,0.4,0.7,0.7,1.6c0.2,0.6,0.5,1.7,0,3C119.1,63.7,118.7,64.2,118.5,64.5z"/>
            <g id="Fire" class="st6">
                <path class="st7" d="M137.2,36.6c2.4,5.9,1.5,14.3-5.7,19.5c-5.1,3.7-12.9,5.3-19.5,4.1c-13.6-2.5-20.3-16.4-20.5-26.4c-0.3-19.1,23.6-32.8,25.6-31.8c0.6,0.3-0.8,1.9-1.1,5.7c-0.3,4.7,1.3,8.3,2.1,10C123,27.7,133.7,28,137.2,36.6z"/>
                <path class="st8" d="M132,41.1c2.6,3.9,3.3,9.9-1,14.2c-3.1,3.1-8.3,4.9-13.2,4.7c-10-0.5-16.9-9.7-18.6-16.6c-3.1-13.4,11.7-25.2,13.3-24.7c0.5,0.2-0.3,1.4,0.1,4.1c0.5,3.3,2.2,5.7,3,6.8C120.5,36.2,128.2,35.4,132,41.1z"/>
                        <path class="st9" d="M128.2,47.6c1.9,2.5,2.3,6.3-1,9c-2.4,2-6.4,3.2-10.1,3.1c-7.6-0.2-12.7-6-13.8-10.4c-2.1-8.5,9.3-16.2,10.5-15.9c0.4,0.1-0.2,0.9,0,2.6c0.3,2.1,1.6,3.6,2.2,4.3C119.6,44.6,125.4,44,128.2,47.6z"/>
            </g>
            <g id="Candlestick">
                <g>
                    <path class="st10" d="M138.8,226.5c0-5,1.8-9.5,4.6-12.5H93.8c2.8,3,4.6,7.5,4.6,12.5s-1.8,9.5-4.6,12.5h49.6C140.6,235.9,138.8,231.5,138.8,226.5z"/>
                    <path class="st11" d="M140.1,218.4c-1.5,1.1-4.3,2.7-8.7,4c-11.2,3.2-22.3,0.6-24,0.2c-2.4-0.6-6.4-1.8-10.3-4.2c-4.2-4.6-6.4-8.6-7.7-11.4c-5-10.8-4.1-22.4-1.6-26.6c0.3-0.5,1.3-2.1,1.3-4.4c0-1.7-0.7-3.1-1.3-4c19.8,0,39.5,0,59.3,0c-0.7,1.1-1.4,2.8-1.3,4.9c0.1,1.9,1,3.3,1.3,3.7c0.4,0.7,6.4,11.4,0,26.3C145.9,209.9,143.8,213.8,140.1,218.4z"/>
                    <path class="st12" d="M168,250H70.8c-0.4,0-0.8-0.4-0.8-0.8v-0.2c0-6,4.9-10.8,10.8-10.8h76.3c6,0,10.8,4.9,10.8,10.8V250z"/>
                    <path class="st10" d="M143.9,159.3c0-2.8,2.4-5.3,6.1-7H83.8c3.8,1.7,6.1,4.2,6.1,7c0,2.8-2.4,5.3-6.1,7h66.3C146.3,164.6,143.9,162.1,143.9,159.3z"/>
                    <path class="st12" d="M155.8,153.5H80.5c-1.9,0-3.4-1.5-3.4-3.4V150c0-1.9,1.5-3.4,3.4-3.4h75.3c1.9,0,3.4,1.5,3.4,3.4v0.1C159.2,152,157.7,153.5,155.8,153.5z"/>
                    <path class="st12" d="M164.6,172.1H73.4c-1.9,0-3.4-1.5-3.4-3.4v-0.1c0-1.9,1.5-3.4,3.4-3.4h91.2c1.9,0,3.4,1.5,3.4,3.4v0.1C168,170.5,166.5,172.1,164.6,172.1z"/>
                </g>
            </g>
        </g>
    </svg>
</template>

<script>
    export default {
        name: "candle",
        props:{
            isTurnOn: {
                type: Boolean,
                default: false,
            }
        }
    }
</script>

<style scoped lang="scss">
    /*Включено*/
    .turnOn{
        /*Огонь*/
        #Fire{display: block !important;}
    }
    .st0{fill:none;stroke:#000000;stroke-miterlimit:10;}
    .st1{fill:#E8DBCD;}
    .st2{fill:#C6B3A1;}
    .st3{fill:#C6B7AB;}
    .st4{fill:#DDCDBC;}
    .st5{fill:#515151;}
    .st6{display:none;}
    .st7{display:inline;fill:#EAC25E;}
    .st8{display:inline;fill:#DDA55B;}
    .st9{display:inline;fill:#E87862;}
    .st10{fill:#605D5A;}
    .st11{fill:#4F4E4D;}
    .st12{fill:#686665;}
</style>